import i18n from "@i18n/i18n";
import { Typography, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Slide, { SlideProps } from "@mui/material/Slide";
import Snackbar, { SnackbarOrigin } from "@mui/material/Snackbar";

export interface State extends SnackbarOrigin {
  open: boolean;
}

function TransitionDown(props: SlideProps) {
  return <Slide {...props} direction="down" />;
}

export const LoadingHeader = ({ loading }: { loading: boolean }) => {
  const theme = useTheme();

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={loading}
      message={
        <Box sx={{ textAlign: "center" }}>
          <Typography>{i18n.t("loading-header.title")}</Typography>
        </Box>
      }
      key={"loading"}
      sx={{
        "&.MuiSnackbar-root": { top: -4 },
        ".MuiPaper-root": { width: "100%", minWidth: 100 },
        ".MuiSnackbarContent-message": { width: "100%" },
      }}
      slots={{
        transition: TransitionDown,
      }}
      slotProps={{
        content: {
          sx: {
            width: "100%",
            color: theme.palette.info.contrastText,
            background: theme.palette.info.main,
          },
        },
      }}
    />
  );
};
